import React from "react";
import '../MessagesData/MessagesData.scss';
import logoUser from '../../../../styles/svg_contacts/user-contact.svg';
import logoUserSelected from '../../../../styles/svg_contacts/user-contact-white.svg';
import logoUserAdd from '../../../../styles/svg_contacts/user-contact-add.svg';
import logoUserAddSelected from '../../../../styles/svg_contacts/user-contact-add-white.svg';
import avatar_img from '../../../../styles/avatar_default.png';
//import { sortedDataMessages } from "../messageslice";
import Config from '../../../../config/config';
import { deleteMessage } from "../../../Authorization/authSlice";
import logoNoteMessage from '../../../../styles/svg_messages/note_mes_data.svg';
import logoNoteMessageSelected from '../../../../styles/svg_messages/note_mes_data_white.svg';
import logoQuizMessage from '../../../../styles/svg_messages/quiz_mes_data.svg';
import logoQuizMessageSelected from '../../../../styles/svg_messages/quiz_mes_data_white.svg';
import logoAddContactMessage from '../../../../styles/svg_messages/new_contact_data.svg';
import logoAddContactMessageSelected from '../../../../styles/svg_messages/new_contact_data_white.svg';

const MessagesData = (props) => {

   // const [selected, setSelected] = useState(false);
    const {dispatch} = props;
    const serverPath = Config.serverPath;
   


    //  SET LOGO USER
    let logoUserSet;
    logoUserSet = logoUser;

    //CHOOSE MESSAGES DATA
    const selectedCategory = Number(props.messagesData.selectedCategory);
  
    // HANDLE DELETE MESSAGE

    const onHandlerDeleteMessage = (e) => {
        const data = {
            userId: props.userId,
            messageId: Number(e.currentTarget.value),
        }
        console.log(data);
        dispatch(deleteMessage(data));

  /*       //ADD DATA TO MESSAGE SLICE FOR SORTING DATA
         const dataForMessages = {
            data: props.messagesDataFromAuth,
            userId: props.userId,
        }
       // console.log(dataForMessages);
       dispatch(sortedDataMessages(dataForMessages));
       */
    }



    const chooseMessagesData = (data, selectedCategory) => {

            let messagesData;
        if (selectedCategory === 1) {
            messagesData = data.messagesUserDataInbox;
        }
        if (selectedCategory === 2) {
            messagesData = data.messagesUserDataSend;
        }
        if (selectedCategory === 3) {
            messagesData = data.messagesDataAdmin;
        }
        //console.log(messagesData);
            return messagesData;
    }







// SELCET ID MESSAGE

const handleClickMessage = (e) => {
    const selectedId = Number(e.currentTarget.value);
    console.log(selectedId);
    
    //dispatch(selectIdOfMessage(selectedId));

    props.onHandlerClickMesssage(selectedId);




}



   //RENDER TABLE FAVORITES
   const renderMessagesTable = () => {

    //CHOOSE DATA FOR MESSAGE
    let chooseUserData; 
    if (selectedCategory === 1) {
        
         chooseUserData = 'user';
      }
    if (selectedCategory === 2) {
        
        chooseUserData = 'contact';
     }
     if (selectedCategory === 3) {
        
        chooseUserData = 'user';
     }

   
 //const chooseUserData = 'user';




   // console.log(props.messagesData);
        let data = chooseMessagesData(props.messagesData,selectedCategory);
        const userId = props.userId;
        //let  data = props.messagesData.messagesUserDataInbox;
    // console.log(data);
  
    // FORMAT DATA
    const formatDate = (item) => {
      let result;
      let time;
      let data;
      let day;
      let month;
      let year;
      data = item.substring(0,10);
      time = item.substring(11,16);
      day = data.substring(8,10); 
      month = data.substring(5,7);   
      year = data.substring(0,4);  

      result = `${time} ${day}/${month}/${year}`;
        return result;
        //return data;
    }



    if (data) {
        return (
            data.map(item => {

               



               // console.log(item.id);
               //console.log(item.id);

            // AVATAR RENDER
            let avatar_src = avatar_img;
           /* if (item[chooseUserData].avatarName.length !==0) {
                 avatar_src = `${serverPath}/api/avatar/${item[chooseUserData].id}/${item[chooseUserData].avatarName}`;
            }
*/
            if (item[chooseUserData].avatarName) {
                avatar_src = `${serverPath}/api/avatar/${item[chooseUserData].id}/${item[chooseUserData].avatarName}`;
           }



            //STYLE IF READ MESSAGE
            let styleReadMessage; 
            if ((!item.read) && (userId !== item.user.id)) {
                styleReadMessage = 'title';
            } else {styleReadMessage = 'title-read'};

            // STYLE SELECTED MESSAGE
            /*let styleSlectedTrMessage;
           // const 
  
            if (item.id === props.messagesData.selectedIdMessage) {
                styleSlectedTrMessage ={
                   backgroundColor:"#018DD8",
                   color: "white",
                  
               } 
            }
               */
            let styleMesButton;
            let styleMesHref;
            if (item.id === props.messagesData.selectedIdMessage) {
                styleMesButton ='mes-button-selected';
                logoUserSet = logoUserSelected;
                
            } else {
                    styleMesButton ='mes-button';
                    logoUserSet = logoUser;
            }
            if (item.mesHref === 7) {
                logoUserSet = logoUserAdd;
                styleMesHref = logoAddContactMessage;
            }
            if ((item.mesHref === 7) && (item.id === props.messagesData.selectedIdMessage)) {
                logoUserSet = logoUserAddSelected;
                styleMesHref = logoAddContactMessageSelected;
            }

            //STYLE MESS HREF
            
            if (item.mesHref === 1) {
                styleMesHref = logoQuizMessage;
            };
            if ((item.mesHref === 1) && (item.id === props.messagesData.selectedIdMessage)) {
                styleMesHref = logoQuizMessageSelected;
            };

            if (item.mesHref === 2) {
                styleMesHref = logoNoteMessage; 
            };
            if ((item.mesHref === 2) && (item.id === props.messagesData.selectedIdMessage)) {
                styleMesHref = logoNoteMessageSelected; 
            };
            


           


            return(
                <tr key={item.id} >
                    <td>
                    
                        <button type = 'button'  className={styleMesButton} value={item.id} onClick={handleClickMessage}>
                            <div className={styleReadMessage}>
                                <div className="logo-info">
                                    <img src={logoUserSet} alt='logo'/>
                                    <img src={avatar_src} alt="Avatar" className='avatar-contact'/>
                                    <p className="user-nickname">{item[chooseUserData].nickName.substring(0,11)}</p>
                                    <img className="logo-mes-href" src={styleMesHref} alt='logo'/>
                                    <span>{item.title.substring(0,4) + '...'}</span>
                                </div>
                               
                                <div className="data">
                                    <p className="data-text">{formatDate(item.data)}</p>
                                </div>
                                
                            </div>
                            
                        </button>
                    </td>
                    <td className='btnCell'><button value={item.id} className='smallbtnDelete' onClick={onHandlerDeleteMessage}></button></td>
                </tr>
                )
            })
        ) 
   }
   
   }






    const messagesView = props.messagesView;
    if (messagesView) {
        return (
            <div className="MessagesData">
                
                        
                        <table>
                                                      
                            <tbody>
                               {renderMessagesTable()} 
                            </tbody>
                        </table>
                    

            </div>
        );   
    } else return null;
    
};
export default MessagesData;